import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type OrderId = Branded<string, "OrderId">;
const orderIdPrefix = "order__";
const {
    factory: orderIdFactory,
    assert: isOrderId,
    zodSchema: orderIdZodSchema,
} = genericId<OrderId>(orderIdPrefix, {
    // dont't match e.g. order_group_ or order_item_ but match order_
    regexMatch: /(?=^order_)(?=(?!order_group_))(?=(?!order_item_))\S+$/,
});

export { isOrderId, orderIdFactory, orderIdPrefix, orderIdZodSchema };
export type { OrderId };
